export default "__VITE_ASSET__Jaesd2Ye__"